export const getDirectionsUrl = (fromAddress, toAddress) => {
    if (!toAddress) {
        return '';
    }

    const from = fromAddress ? fromAddress : '';
    let cp = '';
    let to = '';

    if (toAddress.StreetAddress) {
        to = toAddress.StreetAddress + ', ' + toAddress.City + ', ' +
            toAddress.State + ' ' + toAddress.Zip;
        if (toAddress.Latitude && toAddress.Longitude) {
            cp = '/' + toAddress.Latitude + ',' + toAddress.Longitude;
        }
    }
    else {
        to = toAddress;
    }

    const googleMapurl = 'https://www.google.com/maps/place/' + from + to + cp;
    return googleMapurl;
};

export const getAddressUrl = (address) => {
    let addressUrl = '#';
    if (address) {
        const toAddress = address.StreetAddress + ', ' + address.City + ', ' + address.State + ' ' + address.Zip;
        addressUrl = getDirectionsUrl(null, toAddress);
    }
    return addressUrl;
};

export const findDistance = (lat1, lon1, lat2, lon2, unit) => {
    try {
        if (lat1 === lat2 && lon1 === lon2) {
            return "";
        }
        else {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit === "K") { dist = dist * 1.609344 }
            if (unit === "N") { dist = dist * 0.8684 }
            return dist;
        }
    }
    catch {
        return "";
    }
};

export const formatMiles = (miles) => {
    if (miles) {
        miles = miles.toFixed(2);
        return miles + " Miles Away";
    }
    return "";
};